import React from 'react'
import { Navigate, useRoutes } from 'react-router-dom'
import Dashboard from './layout/dashboard.js'
import Login from './pages/login/login.js'
import SubAdmin from './pages/admin/subAdmin.js'

import { isEmpty } from 'lodash'
import { ACCESS_LEVEL } from './constant/constant.js'
import { useSelector } from 'react-redux'

import Loader from './components/loader.js'
import ProtectedRoute from './layout/protectedRoute.js'

import AdminDashboard from './pages/dashboard/index.js'
// import ChipsMaster from './pages/chipsMaster/index.js'
import Withdrawal from './pages/withdrawalModule/index.js'
import Deposit from './pages/depositModule/index.js'
import Shift from './pages/shiftManagement/index.js'
import OpeningBalance from './pages/openingBalance/index.js'
import LedgerPage from './pages/ledger/index.js'
import PaymentOffers from './pages/paymentOffer/index.js'
import Transaction from './pages/transaction/index.js'
import EditPaymentOffer from './pages/paymentOffer/edit.js'
import AddPaymentOffer from './pages/paymentOffer/add.js'
import ViewUserInfo from './pages/paymentOffer/view.js'
import Loan from './pages/loan/index.js'
import ChipsMaster from './pages/chipsMaster/index.js'
import Rake from './pages/rake/index.js'
import TipManager from './pages/tip/index.js'
import ChipIssue from './pages/chipIssue/index.js'
import ChipCashOut from './pages/chipCashOut/index.js'
import ChipExchange from './pages/chipExchange/index.js'
import FloatExchange from './pages/floatExchange/index.js'
import AppSettings from './pages/settings/index.js'
import UserManager from './pages/userManager/index.js'
import ExpenseManager from './pages/expense/index.js'
import DailyExpenseManager from './pages/dailyExpense/index.js'
import WalletManager from './pages/walletManager/index.js'
import SessionManager from './pages/sessionManager/index.js'
import TelegramCashierPage from './pages/telegramCashier/index.js'
import EmployeeManagerPage from './pages/employeeManager/index.js'
import BadBeatJackpot from './pages/badBeatJackpot/index.js'
import BBJDisplay from './pages/badBeatJackpot/display.js'
import BBJRulesPage from './pages/badBeatJackpot/rulesPage.js'
import DealerHandPage from './pages/dealerHand/index.js'
import DealerHandAdminPage from './pages/dealerHand/admin.js'
import HighHandDisplay from './pages/dealerHand/highHandDisplay.js'
import AccountManager from './pages/accountManager/index.js'
import PlayerManager from './pages/playerManager/index.js'
import LeaderboardPage from './pages/leaderboard/index.js'
import LeaderboardDisplay from './pages/leaderboard/display.js'
import LeaderboardPlayerLookup from './pages/leaderboard/playerLookup.js'
import DealerTipPage from './pages/dealerTip/index.js'
import SpinWheelPage from './pages/spinWheel/index.js'
// import EMIManager from './pages/emi/index.js'



// When this app is served on the dedicated leaderboard domain (REACT_APP_LEADERBOARD_DOMAIN),
// only the leaderboard pages are reachable — no CMS login/dashboard on that host.
const isLeaderboardDomain =
    !!process.env.REACT_APP_LEADERBOARD_DOMAIN &&
    window.location.hostname === process.env.REACT_APP_LEADERBOARD_DOMAIN;

// The CMS itself (dense tables, cashier/admin workflows) is unusable on a phone or
// tablet -- on those devices only the leaderboard pages are reachable, same as the
// dedicated leaderboard domain above. Detected once at module load from the device's
// own user agent, independent of hostname.
const isMobileDevice =
    typeof navigator !== "undefined" &&
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent || "");

const leaderboardDomainRoutes = [
    { path: '/', element: <Navigate to="/leaderboard" replace /> },
    { path: '/leaderboard', element: <LeaderboardPage /> },
    { path: '/leaderboard-display', element: <LeaderboardDisplay /> },
    { path: '/leaderboard-lookup', element: <LeaderboardPlayerLookup /> },
    { path: '/leaderboard-daily-display', element: <LeaderboardDisplay variant="daily" /> },
    { path: '/leaderboard-daily-lookup', element: <LeaderboardPlayerLookup variant="daily" /> },
    { path: '/leaderboard-weekend-display', element: <LeaderboardDisplay variant="weekend" /> },
    { path: '/leaderboard-weekend-lookup', element: <LeaderboardPlayerLookup variant="weekend" /> },
    { path: '/leaderboard-milestone-display', element: <LeaderboardDisplay variant="milestone" /> },
    { path: '/leaderboard-milestone-lookup', element: <LeaderboardPlayerLookup variant="milestone" /> },
    // Opened by scanning the QR on /bbj-display -- almost always from a phone.
    { path: '/bbj-rules', element: <BBJRulesPage /> },
    // Dealers log hands from their phones.
    { path: '/dealer-hand', element: <DealerHandPage /> },
    { path: '*', element: <Navigate to="/leaderboard" replace /> },
];

function Router() {
    const accessCokies = useSelector(state => state.loginSlice);
    let loader = accessCokies.loading ? <Loader /> : null;

    const cmsRoutes = [
        {
            element: <Dashboard />,
            children: [
                {
                    element:  <ProtectedRoute access_level={ACCESS_LEVEL.SUB_ADMIN}/>,
                    children: [

                        {
                            path: '/',
                            element: <Navigate to="/shift-management" replace />
                        },
                        {
                            path: '/opening-balance',
                            element : <OpeningBalance />
                        },
                        {
                            path: '/shift-management',
                            element : <Shift />
                        },
                        {
                            path: '/deposit',
                            element : <Deposit />
                        },
                        {
                            path: '/withdrawal',
                            element : <Withdrawal />
                        },
                        
                        {
                            path: '/transaction',
                            element : <Transaction />
                        },
                        {
                            path: '/chips-master',
                            element : <ChipsMaster />
                        },
                        {
                            path: '/loan',
                            element : <Loan />
                        },
                        {
                            path: '/rake',
                            element : <Rake />
                        },
                        {
                            path: '/tip-manager',
                            element : <TipManager />
                        },
                        {
                            path: '/chip-issue',
                            element : <ChipIssue />
                        },
                        {
                            path: '/chip-cashout',
                            element : <ChipCashOut />
                        },
                        {
                            path: '/chip-exchange',
                            element : <ChipExchange />
                        },
                        {
                            path: '/float-exchange',
                            element : <FloatExchange />
                        },
                        {
                            path: '/expense',
                            element : <ExpenseManager />
                        },
                        {
                            path: '/daily-expense',
                            element : <DailyExpenseManager />
                        },


                    ]
                },
                {
                    element:  <ProtectedRoute access_level={ACCESS_LEVEL.ADMIN}/>,
                    children:[
                        {
                            path:'/sub-admin',
                            element : <SubAdmin/>
                        },
                        {
                            path: '/wallet-manager',
                            element : <WalletManager />
                        },
                        
                        {
                            path:'/dashboard',
                            element : <AdminDashboard/>
                        }, 
                        {
                            path: '/shift-ledger',
                            element : <LedgerPage />
                        },
                        {
                            path: '/session-manager',
                            element : <SessionManager />
                        },
                        {
                            path: '/payment-offer',
                            element : <PaymentOffers />
                        }, 
                        {
                            path: '/payment-offer/add',
                            element : <AddPaymentOffer />
                        },
                        {
                            path: '/payment-offer/view/:id',
                            element : <ViewUserInfo />
                        },
                        {
                            path: '/payment-offer/edit/:id',
                            element : <EditPaymentOffer />
                        },
                        {
                            path: '/settings',
                            element : <AppSettings />
                        },
                        {
                            path: '/user-manager',
                            element : <UserManager />
                        },
                        {
                            path: '/telegram-cashier',
                            element : <TelegramCashierPage />
                        },
                        {
                            path: '/employee-manager',
                            element : <EmployeeManagerPage />
                        },
                        {
                            path: '/bad-beat-jackpot',
                            element : <BadBeatJackpot />
                        },
                        {
                            path: '/hand-entries',
                            element : <DealerHandAdminPage />
                        },
                        {
                            path: '/account-manager',
                            element : <AccountManager />
                        },
                        {
                            path: '/player-manager',
                            element : <PlayerManager />
                        },


                    ]
                },
              
            ]
        },
       
        {
            path: "/login",
            element: !isEmpty(accessCokies.token) ? <Navigate to="/shift-management" replace={true} /> : <Login />,
        },
        {
            path: "/bbj-display",
            element: <BBJDisplay />,
        },
        {
            path: "/bbj-rules",
            element: <BBJRulesPage />,
        },
        {
            path: "/dealer-hand",
            element: <DealerHandPage />,
        },
        {
            path: "/high-hand-display",
            element: <HighHandDisplay />,
        },
        {
            path: "/leaderboard",
            element: <LeaderboardPage />,
        },
        {
            path: "/leaderboard-display",
            element: <LeaderboardDisplay />,
        },
        {
            path: "/leaderboard-lookup",
            element: <LeaderboardPlayerLookup />,
        },
        {
            path: "/leaderboard-daily-display",
            element: <LeaderboardDisplay variant="daily" />,
        },
        {
            path: "/leaderboard-daily-lookup",
            element: <LeaderboardPlayerLookup variant="daily" />,
        },
        {
            path: "/leaderboard-weekend-display",
            element: <LeaderboardDisplay variant="weekend" />,
        },
        {
            path: "/leaderboard-weekend-lookup",
            element: <LeaderboardPlayerLookup variant="weekend" />,
        },
        {
            path: "/leaderboard-milestone-display",
            element: <LeaderboardDisplay variant="milestone" />,
        },
        {
            path: "/leaderboard-milestone-lookup",
            element: <LeaderboardPlayerLookup variant="milestone" />,
        },
        {
            path: "/dealer-tip",
            element: <DealerTipPage />,
        },
        {
            path: "/spin-wheel",
            element: <SpinWheelPage />,
        },

    ]

    const Route = useRoutes((isLeaderboardDomain || isMobileDevice) ? leaderboardDomainRoutes : cmsRoutes)
    return accessCokies.loading ? <Loader /> : Route;
}

export default Router
